const GRAD_YEAR_START_OFFSET = -4;
const GRAD_YEAR_SPAN = 10;

/**
 * Rolling graduation-year range shared by the job forms and student search.
 * Returns 10 years, oldest first: 4 past years, the current year, 5 future.
 * A function, not a constant, so the range follows the calendar year.
 */
export const getGradYears = () => {
    const currentYear = new Date().getFullYear();
    return [...new Array(GRAD_YEAR_SPAN).keys()].map(
        (i) => currentYear + GRAD_YEAR_START_OFFSET + i,
    );
};
